import { combineReducers } from 'redux';
import data from './dataReducer';
import routes from './routesReducer';
import mfc from './mfcReducer';
import ui from './uiReducer';
import filters from './filterServicesReducer';
import servicesCatalog from './servicesCatalogReducer';
import servicesForOffice from './servicesForOfficeReducer';
import nearestMfc from './nearestMfcReducer';

const rootReducer = combineReducers({
  data,
  routes,
  mfc,
  ui,
  filters,
  servicesCatalog,
  servicesForOffice,
  nearestMfc,
});

export default rootReducer;
